/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

const contactModal = document.getElementById('contactModal')
const modalTitle = document.getElementById('contactModalTitle')
const modalBody = document.getElementById('contactModalBody')

contactModal.addEventListener('show.bs.modal', event => {
  const clickedLink = event.relatedTarget
  const plan = clickedLink.dataset.plan
  const planId = clickedLink.dataset.planid
  const contactInfo = document.getElementById(`container-${planId}`)
  modalTitle.innerText = plan
  modalBody.innerHTML = contactInfo.outerHTML
})

export function renderContact (type, data) {
  try {
    return data[type].length === 0
      ? '<span title="not available">n/a</span>'
      : data[type].map(function (next) {
        return `<span>${next.common_name}</span>`
      }).join('<br />')
  } catch (e) {
    return '<span title="not available">n/a</span>'
  }
}

export function renderContactData (data, options) {
  const defaultOptions = {
    gradOnly: false
  }

  const _settings = $.extend({}, defaultOptions, options)

  const planName = data.plan.replace('(PHD)', '(PhD)')
  const admissions = normalizeContact(data.contacts.GADM) ?? '&nbsp;'
  const coordinators = normalizeContact(data.contacts.GCOR) ?? '&nbsp;'
  const dgs = normalizeContact(data.contacts.DGS) ?? '&nbsp;'
  const auditor = normalizeContact(data.contacts.GCAUD) ?? '&nbsp;'

  const website = Object.values(data.owned_by).map(function (next) {
    return `<div class="mb-4 contacts dept">
      <a href="${next.org_website}" class="link-underline link-underline-opacity-0 link-underline-opacity-75-hover">${next.org_name}</a><br />
      <span class="fw-light">${next.college_name}</span>
    </div>`
  }).join('<br />')
  const additionalInfo = `<a href="https://catalog.arizona.edu/programs/${data.saAcadplan}" class="link-underline link-underline-opacity-0 link-underline-opacity-75-hover">
      Catalog Program Description
    </a>
    <br />
    <a href="https://grad.arizona.edu/admissions-guides/#program/${data.uacadplan}" class="link-underline link-underline-opacity-0 link-underline-opacity-75-hover">
      Graduate Admissions Guide
    </a>`

  const contactDetails = _settings.gradOnly
    ? `<dt class="fw-normal"><abbr title="Graduate College Student Support Specialist">Student Support Specialist</abbr></dt>
       <dd>${auditor}</dd>
       <dt class="fw-normal">Additional Information</dt>
       <dd>${additionalInfo}</dd>`
    : `<dt class="fw-normal"><abbr title="Department/Program Admissions Contact">Admissions</abbr></dt>
       <dd>${admissions}</dd>
       <dt class="fw-normal"><abbr title="Graduate Program Coordinator">Coordinator</abbr></dt>
       <dd>${coordinators}</dd>
       <dt class="fw-normal"><abbr title="Director of Graduate Studies">DGS</abbr></dt>
       <dd>${dgs}</dd>
       <dt class="fw-normal"><abbr title="Graduate College Student Support Specialist">Student Support Specialist</abbr></dt>
       <dd>${auditor}</dd>
       <dt class="fw-normal">Dept Website</dt>
       <dd>${website}</dd>
       <dt class="fw-normal">Additional Information</dt>
       <dd>${additionalInfo}</dd>`

  return `<div>
    <a
      data-bs-target="#contactModal"
      data-bs-toggle="modal"
      data-plan="${planName}"
      data-planid="${data.uacadplan}"
      href="#"
      id="${data.uacadplan}"
       class="link-underline link-underline-opacity-0 link-underline-opacity-75-hover"
    >
      ${planName}
    </a>
    <div hidden>
      <dl id="container-${data.uacadplan}">
        ${contactDetails}
      </dl>
    </div>
  </div>`
}

export function normalizePhone (phoneNbr) {
  if (phoneNbr === null) {
    return phoneNbr
  }

  // normalize string and remove all unnecessary characters
  phoneNbr = phoneNbr.replace(/[^\d]/g, '')

  // check if number length equals to 10
  if (phoneNbr.length === 10) {
    // reformat and return phone number
    return phoneNbr.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
  }

  return phoneNbr
}

export function normalizeContact (contact) {
  return contact.length === 0
    ? '<span title="not available">n/a</span>'
    : contact.map(function (next) {
      const phone = next.phone
      if (phone === null) {
        return `<div class="mb-4 contact">
          <a href="mailto:${next.email}" class="link-underline link-underline-opacity-0 link-underline-opacity-75-hover">${next.common_name}</a>
        </div>`
      }

      const normalPhone = normalizePhone(phone)

      return `<div class="mb-4 contact">
        <a href="mailto:${next.email}" class="link-underline link-underline-opacity-0 link-underline-opacity-75-hover">${next.common_name}</a><br />
        <a href="tel:+1${phone}" class="link-underline link-underline-opacity-0 link-underline-opacity-75-hover">${normalPhone}</a>
      </div>`
    }).join('<br />')
}

window.renderContact = renderContact
window.renderContactData = renderContactData
window.normalizePhone = normalizePhone
window.normalizeContact = normalizeContact
